import React, { Component } from 'react'

/**
 * Error boundary for individual prescription sections.
 *
 * Wraps each independently-rendered section (free-form rich text, uploaded images,
 * patient history notes, etc.) so that a missing import or render error in ONE section
 * shows a contained error indicator instead of blanking the entire prescription page.
 *
 * Usage:
 *   <PrescriptionSectionErrorBoundary sectionName="Free-Form Rich Text">
 *     <MySection ... />
 *   </PrescriptionSectionErrorBoundary>
 */
export default class PrescriptionSectionErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, errorMessage: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || String(error) }
  }

  componentDidCatch(error, info) {
    const name = this.props.sectionName || 'Unknown section'
    console.error(`[PrescriptionSection:${name}] Render error:`, error, info?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      const name = this.props.sectionName || 'Section'
      return (
        <div
          style={{
            border: '2px dashed #e53e3e',
            borderRadius: 6,
            padding: '12px 16px',
            margin: 8,
            background: '#fff5f5',
            color: '#c53030',
            fontFamily: 'system-ui, sans-serif',
            fontSize: 13,
          }}
        >
          <strong>{name}</strong> failed to render.
          <br />
          <span style={{ fontSize: 11, color: '#9b2c2c' }}>{this.state.errorMessage}</span>
        </div>
      )
    }

    return this.props.children
  }
}
